module.exports = __webpack_public_path__ + "static/media/background.ce9d53f0.psd";